import { useState } from 'react';

export default function PreLaunchTable() {
  const [showForm, setShowForm] = useState(false);

  const benefits = [
    {
      icon: 'ri-percent-line',
      title: 'Condições Especiais',
      description: 'Preços e condições exclusivas de pré-lançamento'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Pagamento Flexível',
      description: 'Fluxo de pagamento adaptado ao seu planejamento'
    },
    {
      icon: 'ri-key-line',
      title: 'Prioridade na Escolha',
      description: 'Escolha primeiro a unidade dos seus sonhos'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Valorização Garantida',
      description: 'Localização privilegiada com alta valorização'
    }
  ];

  return (
    <section id="reserva" className="py-24 px-6 lg:px-12 bg-gradient-to-br from-gray-900 via-gray-800 to-amber-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-amber-400 text-sm tracking-[0.3em] uppercase mb-4 font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>
            Oportunidade Única
          </p>
          <h2 className="text-5xl lg:text-6xl font-normal text-white mb-6" style={{ fontFamily: 'DM Serif Display, serif' }}>
            Tabela de Pré-Lançamento
          </h2>
          <p className="text-gray-300 text-base max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Reserve sua unidade agora e garanta as melhores condições. Seja para morar ou investir na localização que mais valoriza em Linhares.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white/5 backdrop-blur-sm p-8 rounded-lg border border-white/10 hover:border-amber-400/50 transition-all duration-300"
            >
              <div className="w-14 h-14 mb-6 flex items-center justify-center rounded-full bg-amber-600/20">
                <i className={`${benefit.icon} text-2xl text-amber-400`}></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-3" style={{ fontFamily: 'DM Serif Display, serif' }}>
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-300 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-2xl max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-semibold text-gray-900 mb-4" style={{ fontFamily: 'DM Serif Display, serif' }}>
              Reserve Sua Unidade Agora
            </h3>
            <p className="text-gray-600 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
              Preencha o formulário e nossa equipe entrará em contato com as condições exclusivas
            </p>
          </div>

          <form 
            id="reserva-form"
            data-readdy-form
            action="https://readdy.ai/api/form/d6cv2oaff40lgbk6d540"
            method="POST"
            className="space-y-6"
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              
              // Validação
              const nome = formData.get('nome') as string;
              const email = formData.get('email') as string;
              const telefone = formData.get('telefone') as string;
              
              if (!nome || !email || !telefone) {
                alert('Por favor, preencha todos os campos obrigatórios.');
                return;
              }

              // Envio
              fetch(form.action, {
                method: 'POST',
                body: new URLSearchParams(formData as any),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
              })
                .then(() => {
                  setShowForm(false);
                  alert('Reserva enviada com sucesso! Em breve entraremos em contato.');
                  form.reset();
                })
                .catch(() => {
                  alert('Erro ao enviar. Tente novamente.');
                });
            }}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Nome Completo *
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-amber-600 focus:ring-2 focus:ring-amber-600/20 outline-none transition-all text-sm"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                  E-mail *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-amber-600 focus:ring-2 focus:ring-amber-600/20 outline-none transition-all text-sm"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="telefone" className="block text-sm font-medium text-gray-700 mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Telefone/WhatsApp *
                </label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-amber-600 focus:ring-2 focus:ring-amber-600/20 outline-none transition-all text-sm"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                />
              </div>
              <div>
                <label htmlFor="interesse" className="block text-sm font-medium text-gray-700 mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Interesse
                </label>
                <select
                  id="interesse"
                  name="interesse"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-amber-600 focus:ring-2 focus:ring-amber-600/20 outline-none transition-all text-sm cursor-pointer"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  <option value="morar">Morar</option>
                  <option value="investir">Investir</option>
                  <option value="ambos">Ambos</option>
                </select>
              </div>
            </div>

            <div>
              <label htmlFor="tipo-unidade" className="block text-sm font-medium text-gray-700 mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                Tipo de Unidade
              </label>
              <select
                id="tipo-unidade"
                name="tipo-unidade"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-amber-600 focus:ring-2 focus:ring-amber-600/20 outline-none transition-all text-sm cursor-pointer"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                <option value="2-quartos">2 Quartos</option>
                <option value="3-quartos">3 Quartos</option>
                <option value="indiferente">Indiferente</option>
              </select>
            </div>

            <div>
              <label htmlFor="mensagem" className="block text-sm font-medium text-gray-700 mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                Mensagem (opcional)
              </label>
              <textarea
                id="mensagem"
                name="mensagem"
                rows={4}
                maxLength={500}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-amber-600 focus:ring-2 focus:ring-amber-600/20 outline-none transition-all resize-none text-sm"
                style={{ fontFamily: 'Inter, sans-serif' }}
                placeholder="Conte-nos mais sobre suas necessidades..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1" style={{ fontFamily: 'Inter, sans-serif' }}>Máximo 500 caracteres</p>
            </div>

            <button
              type="submit"
              className="w-full bg-amber-600 text-white py-4 rounded-lg font-semibold text-sm tracking-wide hover:bg-amber-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              GARANTIR MINHA RESERVA
            </button>

            <p className="text-xs text-gray-500 text-center" style={{ fontFamily: 'Inter, sans-serif' }}>
              Ao enviar, você concorda em receber contato da nossa equipe comercial
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}
